/**
 * Compatibility helpers that bridge the old @repo/core/helpers API
 * to the new @repo/unicity helpers API.
 */
import { customerHelpers } from '@helpers'
import type { TCustomer } from '@repo/unicity'

/** Get customer phone number (mobilePhone > workPhone > homePhone) */
export const customerPhone = (customer: TCustomer | undefined | null): string => {
    if (!customer) return ''
    if (customer.mobilePhone) return customer.mobilePhone
    if (customer.workPhone) return customer.workPhone
    if (customer.homePhone) return customer.homePhone
    return ''
}

/** Get customer status shortcode (e.g. 'C', 'H', 'A') */
export const customerStatus = (customer: TCustomer | undefined | null): string => {
    if (!customer) return ''
    return customerHelpers.getStatus(customer)
}

/** Get customer native full name */
export const customerNameNative = (customer: TCustomer | undefined | null): string => {
    if (!customer) return ''
    return customerHelpers.getFullName(customer, true)
}

export const spotlightCustomerHelpers = {
    ...customerHelpers,
    customerPhone,
    customerStatus,
    customerNameNative
}
